const notificationInboxView = require('templates/notification_inbox_item.jst.jade')
import { initAhoyComponent } from "components/shared/ComponentInitializers/ComponentInitializers";
import AhoyEvent from 'shared/ahoy_event';

export default class NotificationInboxItem {
  constructor(data, index){

    var ahoy_props = {
      action: 'click',
      feature: 'notification detail',
      title: data.title,
      position: index
    };

    this.index = index;
    this.shown = false;

    this.item = {
      read: data.read,
      url: data.url,
      title: data.title,
      body: data.body,
      datetime: this.convertTimestampToIso(data.timestamp),
      ahoy_props: JSON.stringify(ahoy_props)
    };
  }

  convertTimestampToIso(timestamp){
    try {
      return new Date(parseInt(timestamp)).toISOString();
    } catch (error) {
      return 0;
    }
  }

  parentChanged(parentTop, parentBottom){
    if (this.shown) {
      return;
    }

    if (this.isShownInsideParent(parentTop, parentBottom)) {
      this.sendImpression();
      this.shown = true;
    }
  }

  sendImpression(){
    AhoyEvent.send("VIDIO::SUBSCRIPTION", {
      feature: 'notification detail',
      action: 'impression',
      title: this.item.title
    });
  }

  getTopBottom(){
    var bounding = this.html[0].getBoundingClientRect();
    var top = bounding.top;
    var bottom = bounding.bottom;

    return {
      top: top,
      bottom: bottom
    };
  }

  isShownInsideParent(parentTop, parentBottom){

    if (parentTop == 0 || parentBottom == 0) {
      return false;
    }

    let topBottom = this.getTopBottom();
    let top = topBottom.top; 
    let bottom = topBottom.bottom; 

    return (
      (top >= parentTop && top <= parentBottom) &&
      (bottom >= parentTop && bottom <= parentBottom)
    );

  }

  render(){
    this.html = $(notificationInboxView(this.item));

    this.html.find('.activity-item__timestamp').timeago();
    initAhoyComponent(this.html.find('.activity-item__link')[0]);

    return this.html;
  }
}